import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import HttpBackend from "i18next-http-backend"

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    ns: ["COMMON", "CHECK"],
    defaultNS: "COMMON",
    fallbackNS: "CHECK",
    cleanCode: true,
    interpolation: {
      escapeValue: true,
    },
    detection: {
      order: ["cookie", "localStorage", "navigator"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: `${process.env.REACT_APP_PNM_I18N_URL}/api/messages/{{ns}}/{{lng}}`,
    },
  })

// Keep <html lang> in step with the language actually shown, so the browser
// does not mistake the page for a foreign one and offer to translate it.
const syncHtmlLang = (lng?: string) => {
  if (lng) document.documentElement.lang = lng.split("-")[0]
}
i18n.on("languageChanged", syncHtmlLang)
syncHtmlLang(i18n.language)

export default i18n
